import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { IconButton } from "@mui/material";

import { CarouselArrowDirection } from "@/src/pages/consumer/HomePage/HomePageImageCarousel/homePageImageCarousel.constants";
import { buildArrowSx } from "@/src/pages/consumer/HomePage/HomePageImageCarousel/homePageImageCarousel.styles";

interface HomePageCarouselArrowProps {
  direction: CarouselArrowDirection;
  label: string;
  onClick: () => void;
}

const HomePageCarouselArrow = (props: HomePageCarouselArrowProps) => {
  const { direction, label, onClick } = props;
  const isLeft = direction === "left";

  return (
    <IconButton
      aria-label={label}
      onClick={onClick}
      sx={buildArrowSx(direction)}
    >
      {isLeft ? (
        <ChevronLeftIcon fontSize="small" />
      ) : (
        <ChevronRightIcon fontSize="small" />
      )}
    </IconButton>
  );
};

export default HomePageCarouselArrow;
